<template>
  <div>
    <div class="modal bg-opacity-50 bg-black" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Character Equipments</h5>
            <span aria-hidden="true" role="button" @click="close"
              ><i class="fas fa-xmark"></i
            ></span>
          </div>
          <div class="modal-body">
            <div class="container mb-3">
              <div class="row mb-3">
                <button class="btn btn-primary" @click="showAdd = true" v-if="data.isAdd">
                  Add Equipment
                </button>
                <div class="container py-3">
                  <div class="row">
                    <div class="col">
                      <span>Equipment Status</span>
                      <div class="d-flex flex-wrap gap-2" role="group">
                        <label
                          v-for="(value, key) in this.equipmentStatusType"
                          :key="key"
                          class="btn btn-outline-primary"
                          :for="`eq-${key}`"
                          data-toggle="buttons"
                          :class="{
                            active: this.selectedEquipmentStatus == value,
                          }"
                        >
                          <input
                            type="radio"
                            :id="`eq-${key}`"
                            class="btn-check"
                            v-model="this.selectedEquipmentStatus"
                            :value="value"
                            @change="this.toggleEquipmentStatus()"
                          />{{ key }}
                        </label>
                      </div>
                    </div>
                    <!-- <div class="col">
                     <span>Equipment Element</span>
                      <div class="d-flex flex-wrap gap-2" role="group">
                        <label
                          v-for="(value, key) in this.equipmentElements"
                          :key="key"
                          class="btn btn-outline-primary"
                          :for="`elm-${key}`"
                          data-toggle="buttons"
                          :class="{
                            active: this.selectedEquipElement == value,
                          }"
                        >
                          <input
                            type="radio"
                            :id="`elm-${key}`"
                            class="btn-check"
                            v-model="this.selectedEquipElement"
                            :value="value"
                            @change="this.toggleEquipElement()"
                          />{{ key }}
                        </label>
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
              <PageLoader v-if="this.isLoading">Fetching Equipments</PageLoader>
              <data-table2
                :api="getEquipments"
                :lista="store.custom.equipmentList"
                :actions="actions"
                :headers="headers"
                :mainfilter="this.mainFilter"
                :fields="['equipment_id']"
                :trigger="trigger"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="close">Close</button>
          </div>
        </div>
      </div>
    </div>
    <!--Add Equipment-->
    <div class="modal bg-opacity-50 bg-black" tabindex="-1" role="dialog" v-if="showAdd">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add Equipment</h5>
            <span aria-hidden="true" role="button" @click="closeModal"
              ><i class="fas fa-xmark"></i
            ></span>
          </div>
          <div class="modal-body">
            <!--Equipment Types-->
            <div class="row">
              <div class="container">
                <div class="d-flex flex-wrap gap-2" role="group">
                  <label
                    v-for="(value, key) in equipmentType"
                    :key="key"
                    class="btn btn-outline-primary"
                    :for="`rdb-${key}`"
                    data-toggle="buttons"
                    :class="{
                      active: EquipmentFilter.selectedEquipmentType === value,
                    }"
                  >
                    <input
                      type="radio"
                      :id="`rdb-${key}`"
                      class="btn-check"
                      v-model="EquipmentFilter.selectedEquipmentType"
                      :value="value"
                      @change="this.toggleEquipmentType()"
                    />{{ key }}
                  </label>
                </div>
              </div>
            </div>
            <!-- Equipable Type -->
            <div
              class="row py-2"
              v-if="
                EquipmentFilter.selectedEquipmentType === equipmentType.Costume ||
                EquipmentFilter.selectedEquipmentType === equipmentType.Equipable
              "
            >
              <div class="row">
                <div class="col" v-for="(value, key) in equipableType" :key="key">
                  <div
                    class="form-check"
                    v-if="EquipmentFilter.selectedEquipmentType === equipmentType.Costume"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :value="value"
                      :id="`chk_${key}`"
                      :checked="EquipmentFilter.selectedEquipableTypes.includes(value)"
                      @change="toggleEquipableType(value)"
                    />
                    <label class="form-check-label" :for="`chk_${key}`">{{ key }}</label>
                  </div>
                  <div
                    class="form-check"
                    v-if="
                      EquipmentFilter.selectedEquipmentType === equipmentType.Equipable &&
                      value != 4 &&
                      value != 5
                    "
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :value="value"
                      :id="`chk_${key}`"
                      :checked="EquipmentFilter.selectedEquipableTypes.includes(value)"
                      @change="toggleEquipableType(value)"
                    />
                    <label class="form-check-label" :for="`chk_${key}`">{{ key }}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Classes
            <div
              class="row py-3"
              v-if="
                weaponEquipable &&
                EquipmentFilter.selectedEquipmentType === equipmentType.Equipable
              "
            >
              <div
                class="btn-group row"
                role="group"
                aria-label="Basic checkbox toggle button group"
              >
                <div class="col" v-for="(value, key) in classType" :key="key">
                  <input
                    type="checkbox"
                    class="btn-check w-100"
                    :id="`chk_${key}`"
                    autocomplete="off"
                    :value="value"
                    :checked="EquipmentFilter.selectedClass.includes(value)"
                    @change="toggleClass(value)"
                  />
                  <label class="btn btn-outline-primary w-100" :for="`chk_${key}`">{{
                    key
                  }}</label>
                </div>
              </div>
            </div>
            Equipment StatType
            <div
              class="row"
              v-if="
                weaponEquipable &&
                EquipmentFilter.selectedEquipmentType === equipmentType.Equipable
              "
            >
              <div
                class="btn-group row"
                role="group"
                aria-label="Basic checkbox toggle button group"
              >
                <div class="col" v-for="(value, key) in statType" :key="key">
                  <input
                    type="checkbox"
                    class="btn-check w-100"
                    :id="`chk_${key}`"
                    autocomplete="off"
                    :value="value"
                    :checked="EquipmentFilter.selectedStats.includes(value)"
                    @change="toggleStats(value)"
                  />
                  <label class="btn btn-outline-danger w-100" :for="`chk_${key}`">{{
                    key
                  }}</label>
                </div>
              </div>
            </div> -->
            <div class="form-group pt-3">
              <label>Equipment</label>
              <input
                type="text"
                class="form-control"
                name="inpsel_equipment_id"
                autocomplete="off"
                placeholder="Equipment Name"
                @input="this.updateEquipmentId()"
                @change="this.updateEquipmentId()"
                v-model="this.selectedEquipment"
                list="addequipment-list"
                id="inpsel_equipid"
              />
              <datalist id="addequipment-list">
                <option
                  :value="equipment.name"
                  :data-id="equipment.id"
                  v-for="equipment in this.equipmentList"
                  :key="equipment"
                >
                  {{ equipment.name }}
                </option>
              </datalist>
            </div>
            <div class="container">
              <div class="row">
                <div class="col">
                  <div class="form-check checkbox-group">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :value="model.isNonDrop"
                      v-model="model.isNonDrop"
                    />
                    <label class="form-check-label" for="chk_ind">Is Non Drop</label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-check checkbox-group">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :value="EquipmentFilter.isExpiration"
                      v-model="EquipmentFilter.isExpiration"
                    />
                    <label class="form-check-label" for="chk_ind">Has Expiration</label>
                  </div>
                </div>
              </div>
              <div
                class="row"
                v-if="
                  EquipmentFilter.selectedEquipmentType === equipmentType.Costume ||
                  EquipmentFilter.selectedEquipmentType === equipmentType.Equipable
                "
              >
                <div class="col">
                  <div class="form-group checkbox-group">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :value="this.model.isEquiped"
                      v-model="this.model.isEquiped"
                    />
                    <label class="form-check-label" for="chk_ieq">Is Equipped</label>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="stat-group"
              v-if="
                EquipmentFilter.selectedEquipmentType === equipmentType.Costume ||
                EquipmentFilter.selectedEquipmentType === equipmentType.Equipable
              "
            >
              <p class="fs-5 mt-3">Equipment Stats</p>
              <div class="container py-2" v-if="enableBasicStats">
                <p class="fs-6 my-0 fst-italic fw-bold">Basic Stats:</p>
                <div class="row" v-for="(row, index) of editEquipmentFields" :key="index">
                  <div class="col" v-for="field of row" :key="field">
                    <div class="form-group">
                      <div class="input-labels">
                        <label>{{ field.label }}</label>
                        <small v-if="field.note != ''">{{ field.note }}</small>
                      </div>
                      <input
                        type="number"
                        :id="`inp_${field.fieldName}`"
                        class="form-control"
                        v-model="this.model[field.fieldName]"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="container py-2" v-if="enableElementalWeapons">
                <p class="fs-6 my-0 fst-italic fw-bold">Weapon Stats:</p>
                <div class="row">
                  <div
                    class="col"
                    v-for="(field, index) in this.WeaponStats"
                    :key="index"
                  >
                    <div class="form-group">
                      <div class="input-labels">
                        <label>{{ field.label }}</label>
                        <small v-if="field.note != ''">{{ field.note }}</small>
                      </div>
                      <input
                        type="number"
                        :id="`inp_${field.fieldName}`"
                        class="form-control"
                        v-model="this.model[field.fieldName]"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="container py-2" v-if="enableMountPetStats">
                <p class="fs-6 my-0 fst-italic fw-bold">Mount/Pet Stats</p>
                <div class="row">
                  <div
                    class="col"
                    v-for="(field, index) in this.MountPetStats"
                    :key="index"
                  >
                    <div class="form-group">
                      <div class="input-labels">
                        <label>{{ field.label }}</label>
                        <small v-if="field.note != ''">{{ field.note }}</small>
                      </div>
                      <input
                      v-if="field.type =='number'"
                        type="number"
                        :id="`inp_${field.fieldName}`"
                        class="form-control"
                        v-model="this.model[field.fieldName]"
                      />
                      <!-- <div class="d-flex gap-3" v-if="enablePetSkill">
                        <select class="form-control" v-model="this.model[field.fieldName][0]" v-if="field.type =='selection'">
                          <option :value="0">None</option>
                          <option v-for="skill of learnedPetSkill" :key="skill.id" :value="skill.id">{{ skill.name }}</option>
                        </select>
                        <select class="form-control" v-model="this.model[field.fieldName][1]" v-if="field.type =='selection'">
                          <option :value="0">None</option>
                          <option v-for="skill of learnedPetSkill" :key="skill.id" :value="skill.id">{{ skill.name }}</option>
                        </select>
                      </div>
                      <div class="d-flex gap-3" v-else>
                        <input type="text" class="form-control" disabled v-if="field.type =='selection'">
                        <input type="text" class="form-control" disabled v-if="field.type =='selection'">
                      </div>   -->
                      <div class="d-flex gap-3">
                        <input type="text" class="form-control" disabled v-if="field.type =='selection'">
                        <input type="text" class="form-control" disabled v-if="field.type =='selection'">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container py-2" v-if="enableElementResistance">
                <p class="fs-6 my-0 fst-italic fw-bold">Armor Stats:</p>
                <div class="row">
                  <div class="col" v-for="(field, index) in this.ArmorStats" :key="index">
                    <div class="form-group">
                      <div class="input-labels">
                        <label>{{ field.label }}</label>
                        <small v-if="field.note != ''">{{ field.note }}</small>
                      </div>
                      <input
                        type="number"
                        :id="`inp_${field.fieldName}`"
                        class="form-control"
                        v-model="this.model[field.fieldName]"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="container py-2" v-if="enableElementalWeapons">
                <p class="fs-6 my-0 fst-italic fw-bold">Weapon Elemental Stats</p>
                <div class="row">
                  <div class="col" v-for="field of ElementalWeapons" :key="field">
                    <div class="form-group">
                      <div class="input-labels">
                        <label>{{ field.label }}</label>
                        <small v-if="field.note != ''">{{ field.note }}</small>
                      </div>
                      <input
                        type="number"
                        :id="`inp_${field.fieldName}`"
                        class="form-control"
                        v-model="this.model[field.fieldName]"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="container py-2" v-if="enableElementResistance">
                <p class="fs-6 my-0 fst-italic fw-bold">
                  Elemental Resistance (max: 15, min: 0)
                </p>
                <div class="row">
                  <div
                    class="col"
                    v-for="(elementRes, index) in this.elementResistance"
                    :key="index"
                  >
                    <div class="form-group">
                      <label class="text-capitalize">{{ elementRes }}</label>
                      <input
                        type="number"
                        :id="`inp_${elementRes}res`"
                        class="form-control"
                        v-model="this.model.elements[index]"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="my-3">
              <div class="form-group" v-if="!EquipmentFilter.isExpiration">
                <label>Quantity</label>
                <input
                  type="number"
                  id="inp_qty"
                  class="form-control"
                  required
                  v-model="this.model.quantity"
                />
              </div>
              <div class="form-group" v-if="EquipmentFilter.isExpiration">
                <label>Expiration</label>
                <select
                  name="inp_exp"
                  class="form-control"
                  id="inp_exp"
                  required
                  v-model="this.expiryTicks"
                  @change="this.computeAdditionalTicks(this.expiryTicks)"
                >
                  <option
                    :value="this.calculateTicksFromHours(value)"
                    v-for="(value, key) in this.expirationSelect"
                    :key="key"
                  >
                    {{ key.replace("_", "") }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              Close
            </button>
            <button type="button" class="btn btn-success" @click="addEquipment">
              Add Equipment
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Update Equipment-->
    <div
      class="modal bg-opacity-50 bg-black"
      tabindex="-1"
      role="dialog"
      v-if="equipmentToUpdate.show"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Updating {{ this.equipmentToUpdate.entity.equipment_name }} Stats
            </h5>
            <span aria-hidden="true" role="button" @click="closeModal"
              ><i class="fas fa-xmark"></i
            ></span>
          </div>
          <div class="modal-body">
            <p class="fs-5">{{ this.equipmentToUpdate.entity.equipment_name }}</p>

            <hr />
            <div class="stat-group">
              <p class="fs-5">Equipment Stats</p>
              <div class="container">
                <div class="row">
                  <div class="col">
                    <div class="form-group checkbox-group">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="this.equipmentToUpdate.entity.isNonDrop"
                        v-model="this.equipmentToUpdate.entity.isNonDrop"
                      />
                      <label class="form-check-label" for="chk_ind">Is Non Drop</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="form-group checkbox-group">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="this.equipmentToUpdate.entity.isEquiped"
                        v-model="this.equipmentToUpdate.entity.isEquiped"
                      />
                      <label class="form-check-label" for="chk_ieq">Is Equipped</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label class="" for="inp_status">Status</label>
                      <select
                        name="inp_status"
                        class="form-control"
                        id="inp_status"
                        required
                        v-model="this.equipmentToUpdate.entity.status"
                        :value="this.equipmentToUpdate.entity.status"
                      >
                        <option
                          :value="value"
                          v-for="(value, key) in this.activeEquipmentStatus"
                          :key="key"
                        >
                          {{ key }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container py-2" v-if="enableUpdateBasicStats">
                <p class="fs-6 my-0 fst-italic fw-bold">Basic Stats:</p>
                <div class="row" v-for="(row, index) of editEquipmentFields" :key="index">
                  <div class="col" v-for="field of row" :key="field">
                    <div class="form-group">
                      <div class="input-labels">
                        <label>{{ field.label }}</label>
                        <small v-if="field.note != ''">{{ field.note }}</small>
                      </div>
                      <input
                        type="number"
                        :id="`inp_${field.fieldName}`"
                        class="form-control"
                        v-model="this.equipmentToUpdate.entity[field.fieldName]"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="container py-2" v-if="enableUpdateMountPetStats">
                <p class="fs-6 my-0 fst-italic fw-bold">Mount/Pet Stats:</p>
                <div class="row">
                  <div
                    class="col"
                    v-for="(field, index) in this.MountPetStats"
                    :key="index"
                  >
                    <div class="form-group">
                      <div class="input-labels">
                        <label>{{ field.label }}</label>
                        <small v-if="field.note != ''">{{ field.note }}</small>
                      </div>
                      <input
                        v-if="field.type == 'number'"
                        type="number"
                        :id="`inp_${field.fieldName}`"
                        class="form-control"
                        v-model="this.equipmentToUpdate.entity[field.fieldName]"
                      />
                      <div class="d-flex gap-3" v-if="enableUpdatePetSkill">
                        <select class="form-control" v-model="this.equipmentToUpdate.entity[field.fieldName][0]" v-if="field.type =='selection'">
                          <option :value="0">None</option>
                          <option v-for="skill of learnedPetSkill" :key="skill.id" :value="skill.id">{{ skill.name }}</option>
                        </select>
                        <select class="form-control" v-model="this.equipmentToUpdate.entity[field.fieldName][1]" v-if="field.type =='selection'">
                          <option :value="0">None</option>
                          <option v-for="skill of learnedPetSkill" :key="skill.id" :value="skill.id">{{ skill.name }}</option>
                        </select>
                      </div>
                      <div class="d-flex gap-3" v-else>
                        <input type="text" class="form-control" disabled v-if="field.type =='selection'">
                        <input type="text" class="form-control" disabled v-if="field.type =='selection'">
                      </div>  
                    </div>
                  </div>
                </div>
              </div>
              <div class="container py-2" v-if="enableUpdateElementalWeapons">
                <p class="fs-6 my-0 fst-italic fw-bold">Weapon Stats:</p>
                <div class="row">
                  <div
                    class="col"
                    v-for="(field, index) in this.WeaponStats"
                    :key="index"
                  >
                    <div class="form-group">
                      <div class="input-labels">
                        <label>{{ field.label }}</label>
                        <small v-if="field.note != ''">{{ field.note }}</small>
                      </div>
                      <input
                        type="number"
                        :id="`inp_${field.fieldName}`"
                        class="form-control"
                        v-model="this.equipmentToUpdate.entity[field.fieldName]"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="container py-2" v-if="enableUpdateElementResistance">
                <p class="fs-6 my-0 fst-italic fw-bold">Armor Stats:</p>
                <div class="row">
                  <div class="col" v-for="(field, index) in this.ArmorStats" :key="index">
                    <div class="form-group">
                      <div class="input-labels">
                        <label>{{ field.label }}</label>
                        <small v-if="field.note != ''">{{ field.note }}</small>
                      </div>
                      <input
                        type="number"
                        :id="`inp_${field.fieldName}`"
                        class="form-control"
                        v-model="this.equipmentToUpdate.entity[field.fieldName]"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="container py-2" v-if="enableUpdateElementalWeapons">
                <p class="fs-6 my-0 fst-italic fw-bold">Weapon Elemental Stats</p>
                <div class="row">
                  <div class="col" v-for="field of ElementalWeapons" :key="field">
                    <div class="form-group">
                      <div class="input-labels">
                        <label>{{ field.label }}</label>
                        <small v-if="field.note != ''">{{ field.note }}</small>
                      </div>
                      <input
                        type="number"
                        :id="`inp_${field.fieldName}`"
                        class="form-control"
                        v-model="this.equipmentToUpdate.entity[field.fieldName]"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="container py-3" v-if="enableUpdateElementResistance">
                <p class="fs-6 my-0 fst-italic fw-bold">
                  Elemental Resistance
                  <small class="text-capitalize fst-italic">(max: 15, min: 0)</small>
                </p>
                <div class="row">
                  <div
                    class="col"
                    v-for="(elementRes, index) in this.elementResistance"
                    :key="index"
                  >
                    <div class="form-group">
                      <label class="text-capitalize">{{ elementRes }}</label>
                      <input
                        type="number"
                        :id="`inp_${elementRes}res`"
                        class="form-control"
                        v-model="this.equipmentToUpdate.entity.elements[index]"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="form-group px-2 my-2"
              v-if="this.equipmentToUpdate.entity.expiration === 0"
            >
              <label>Quantity</label>
              <input
                type="number"
                id="inp_qty"
                class="form-control"
                v-model="this.equipmentToUpdate.entity.quantity"
                required
              />
            </div>
            <div class="form-group" v-if="this.equipmentToUpdate.entity.expiration > 0">
              <label>Change Current Expiration Date </label>
              <span class="text-danger">{{
                this.ticksToDate(this.equipmentToUpdate.entity.expiration)
              }}</span>
              <select
                name="inp_exp"
                class="form-control"
                id="inp_exp"
                required
                v-model="this.expiryTicks"
                @change="this.computeAdditionalTicks(this.expiryTicks)"
              >
                <option
                  :value="this.calculateTicksFromHours(value)"
                  v-for="(value, key) in this.expirationSelect"
                  :key="key"
                >
                  {{ key.replace("_", "") }}
                </option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              Close
            </button>
            <button type="button" class="btn btn-success" @click="updateEquipment">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--Error Equipment-->
    <div
      class="modal bg-opacity-50 bg-black"
      tabindex="-1"
      role="dialog"
      v-if="showError"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Validation Error</h5>
            <span aria-hidden="true" role="button" @click="showError = false"
              ><i class="fas fa-xmark"></i
            ></span>
          </div>
          <div class="modal-body">
            <ul class="text-danger">
              <li v-for="error in this.errorList" :key="error">{{ error }}</li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showError = false">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal bg-opacity-50 bg-black"
      tabindex="-1"
      role="dialog"
      v-if="showDestroyModal"
    >
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Destroy Item?</h5>
            <span aria-hidden="true" role="button" @click="closeDestroyModal()"
              ><i class="fas fa-xmark"></i
            ></span>
          </div>
          <div class="modal-body">
            <div class="d-flex justify-content-between px-4">
              <button type="button" class="btn btn-lg btn-danger" @click="confirmDestroy">
                Yes
              </button>
              <button
                type="button"
                class="btn btn-lg btn-secondary"
                @click="cancelDestroy"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ViewEquipment
      :data="this.equipmentView"
      v-if="this.equipmentView.show"
    ></ViewEquipment>
  </div>
</template>

<script>
import DataTable2 from "./DataTable/DataTable2.vue";
import ToastService from "toast/src/services/toast";
import ModalService from "modal/src/services/Modal";
import PageLoader from "./Loaders/PageLoader.vue";
import ViewEquipment from "./Modals/ViewEquipment.vue";
import store from "node-back-client/src/store";
export default {
  name: "EquipmentsModal",
  data() {
    return {
      store: store,
      trigger: {},
      showAdd: false,
      showReward: false,
      showError: false,
      showDestroyModal: false,
      isDestroy: false,
      errorList: [],
      equipmentList: [],
      mainFilter: { character_id: this.data.entity.id, status: 0 },
      headers: {
        id: "ID",
        equipment_name: "Equipment Name",
        quantity: "Quantity",
        equipment_equipped: "Equip",
        equipment_element: "el",
        expirationDate: "Expiration Date",
      },
      actions: [
        {
          classNames: "fas fa-magnifying-glass text-warning",
          callback: this.viewEquipment,
        },
        {
          classNames: "fa-solid fa-pen-to-square text-success",
          callback: this.updateEquipments,
        },
        {
          classNames: "fa-solid fa-trash text-danger",
          callback: this.deleteItem,
        },
      ],
      equipmentData: {
        show: false,
        entity: null,
      },
      equipmentToUpdate: {
        show: false,
        entity: null,
      },
      equipmentView: {
        show: false,
        entity: null,
      },
      equipmentElements: {
        None: 0,
        Fire: 1,
        Electric: 2,
        Ice: 3,
        Poison: 4,
      },
      equipmentType: {
        Equipable: 0,
        Pots: 1,
        Scroll: 2,
        Upgrade: 3,
        Card: 4,
        Box: 5,
        Gold: 6,
        Costume: 7,
        Bundle: 8,
        Coupon: 9,
        Food: 10,
        Others: 13,
      },
      equipableType: {
        Armor: 0,
        Shoes: 1,
        Pants: 2,
        Necklace: 3,
        Weapon: 6,
        Ring: 7,
        Earing: 8,
        Vehicle: 9,
        Pet: 10,
        Style: 4,
        Wings: 5,
      },
      classType: {
        Swordsman: 0,
        Archer: 1,
        Brawler: 2,
        Shaman: 3,
        Gunner: 4,
      },
      statType: {
        Strength: 0,
        Agility: 1,
        Intelligence: 2,
        ETC: 3,
      },
      expirationSelect: {
        _1hour: 1,
        _2hours: 1,
        _5hours: 5,
        _7hours: 7,
        _12hours: 12,
        _1day: 24,
        _3days: 72,
        _5days: 120,
        _10days: 240,
        _15days: 360,
        _1month: 720,
        _2months: 1440,
        _3months: 2160,
      },
      elementResistance: ["fire", "electric", "ice", "poison"],
      model: {
        hp: 0,
        energy: 0,
        level: 0,
        rv: 0,
        critRate: 0,
        hitRate: 0,
        evasion: 0,
        magicDefense: 0,
        element: 0,
        elementLevel: 0,
        engraveLevel: 0,
        elements: {
          0: 0,
          1: 0,
          2: 0,
          3: 0,
        },
        equippedSkills:[],
        quantity: 1,
        expiration: 0,
        isNonDrop: false,
        isEquiped: false,
        status: 0,
      },
      expiryTicks: Number,
      skillEquipments: [],
      EquipmentFilter: {
        selectedEquipmentType: 0,
        selectedEquipableTypes: [],
        selectedClass: [],
        selectedStats: [],
        isExpiration: false,
      },
      equipmentStatusType: {
        Active: 0,
        Dropped: 1,
        Destroyed: 2,
        Null: null,
      },
      activeEquipmentStatus: {
        Active: 0,
        Dropped: 1,
        Destroyed: 2,
      },
      selectedEquipment: "",
      selectedEquipmentStatus: 0,
      selectedEquipElement: 0,
      isLoading: false,
      epochticks: 621355968000000000, //Workaround for js datetime, which starts at january, 1 1970 while c# starts at january 1, 0001
      editEquipmentFields: [
        [],
        [
          {
            label: "Level",
            note: "max: 9, min:0",
            type: "number",
            fieldName: "level",
          },
          {
            label: "Random Value(RV)",
            note: "max: 8, min:0",
            type: "number",
            fieldName: "rv",
          },
          {
            label: "Engrave Level",
            note: "max: 30, min:0",
            type: "number",
            fieldName: "engraveLevel",
          },
        ],
      ],
      WeaponStats: [
        {
          label: "Critical Rate",
          note: "max: 15, min:0",
          type: "number",
          fieldName: "critRate",
        },
        {
          label: "Hit Rate",
          note: "max: 7, min:-7",
          type: "number",
          fieldName: "hitRate",
        },
      ],
      MountPetStats: [
        {
          label: "Energy",
          note: "max: 65,532, min:0",
          type: "number",
          fieldName: "energy",
        },
        {
          label: "Pet Skill",
          note: "",
          type: "selection",
          fieldName: "equippedSkills",
        },
      ],
      ArmorStats: [
        {
          label: "Health Points",
          note: "max: 3, min:0",
          type: "number",
          fieldName: "hp",
        },
        {
          label: "Evasion",
          note: "max: 7, min:-7",
          type: "number",
          fieldName: "evasion",
        },
        {
          label: "Magic Defense",
          note: "max: 3, min:0",
          type: "number",
          fieldName: "magicDefense",
        },
      ],
      ElementalWeapons: [
        {
          label: "Element",
          note: "fire/blaze: 1, electric/lightning:2, ice/frozen:3, poison/venom:4",
          type: "number",
          fieldName: "element",
        },
        {
          label: "Element Level",
          note: "max: 1, min:0",
          type: "number",
          fieldName: "elementLevel",
        },
      ],
    };
  },
  props: {
    data: {
      entity: Object,
      show: Boolean,
    },
    api: Object,
    server: Number,
  },
  components: {
    DataTable2,
    PageLoader,
    ViewEquipment,
  },
  computed: {
    currentEquipment(){
      let equipment = this.store.custom.equipmentList.find(
        (equipment) => equipment.id === this.model?.equipment_id
      );
      return equipment
    },
    updateCurrentEquipment(){
      let currentEquipment = this.store.custom.equipmentList.find(
        (equipment) => equipment.id === this.equipmentToUpdate?.entity?.equipment_id
      );
      return currentEquipment
    },
    learnedPetSkill(){
      const setIds = new Set(this.equipmentToUpdate?.entity?.learnedSkills);
      setIds.add(1);
      return this.store.custom.petskillList.filter(item => setIds.has(item.id));
    },
    enableBasicStats() {
      let equipment = this.currentEquipment;
      if (equipment?.name == "") return false;
      if (!equipment) return false;
      return (
        equipment?.equipable.type === 0 ||
        equipment?.equipable.type === 1 ||
        equipment?.equipable.type === 2 ||
        equipment?.equipable.type === 3 ||
        equipment?.equipable.type === 6 ||
        equipment?.equipable.type === 7 ||
        equipment?.equipable.type === 8
      );
    },
    enableUpdateBasicStats() {
      let equipment = this.updateCurrentEquipment
      if (equipment?.name == "") return false;
      if (!equipment) return false;
      return (
        equipment?.equipable.type === 0 ||
        equipment?.equipable.type === 1 ||
        equipment?.equipable.type === 2 ||
        equipment?.equipable.type === 3 ||
        equipment?.equipable.type === 6 ||
        equipment?.equipable.type === 7 ||
        equipment?.equipable.type === 8
      );
    },
    weaponEquipable() {
      return this.EquipmentFilter.selectedEquipableTypes.some(
        (item) => item["equipable.type"] === 6
      );
    },
    enablePetSkill(){
      let equipment = this.currentEquipment;
      if (equipment?.name == "") return false;
      if (!equipment) return false;
      return equipment?.equipable.type === 10;
    },
    enableUpdatePetSkill(){
      let equipment = this.updateCurrentEquipment;
      if (equipment?.name == "") return false;
      if (!equipment) return false;
      return equipment?.equipable.type === 10;
    },
    enableElementResistance() {
      let equipment = this.currentEquipment;
      if (equipment?.name == "") return false;
      if (!equipment) return false;
      return (
        equipment?.equipable.type === 0 ||
        equipment?.equipable.type === 1 ||
        equipment?.equipable.type === 2 ||
        equipment?.equipable.type === 3 ||
        equipment?.equipable.type === 7 ||
        equipment?.equipable.type === 8
      );
    },
    enableMountPetStats() {
      let equipment = this.currentEquipment
      if (equipment?.name == "") return false;
      if (!equipment) return false;
      return equipment?.equipable.type === 9 || equipment?.equipable.type === 10;
    },
    enableUpdateMountPetStats() {
      let equipment = this.updateCurrentEquipment
      if (equipment?.name == "") return false;
      if (!equipment) return false;
      return equipment?.equipable.type === 9 || equipment?.equipable.type === 10;
    },
    enableElementalWeapons() {
      let equipment = this.currentEquipment;
      if (equipment?.name == "") return false;
      if (!equipment) return false;
      return equipment?.equipable.type === 6;
    },
    enableUpdateElementResistance() {
      let equipment = this.updateCurrentEquipment
      if (equipment?.name == "") return false;
      if (!equipment) return false;
      return (
        equipment?.equipable.type === 0 ||
        equipment?.equipable.type === 1 ||
        equipment?.equipable.type === 2 ||
        equipment?.equipable.type === 3 ||
        equipment?.equipable.type === 7 ||
        equipment?.equipable.type === 8
      );
    },
    enableUpdateElementalWeapons() {
      let equipment = this.updateCurrentEquipment
      if (equipment?.name == "") return false;
      if (!equipment) return false;
      return equipment?.equipable.type === 6;
    },
  },
  methods: {
    deleteItem() {
      alert("Currently not available. for display only");
    },
    toggleEquipableType(typeName) {
      let value = { "equipable.type": typeName };
      if (
        this.EquipmentFilter.selectedEquipableTypes.some(
          (type) => type["equipable.type"] === typeName
        )
      ) {
        this.EquipmentFilter.selectedEquipableTypes = this.EquipmentFilter.selectedEquipableTypes.filter(
          (type) => type["equipable.type"] !== typeName
        );
      } else {
        this.EquipmentFilter.selectedEquipableTypes.push(value);
      }
      this.EquipmentFilter.selectedClass = [];
      this.EquipmentFilter.selectedStats = [];
      this.popEquipments();
    },

    toggleClass(className) {
      let field =
        this.EquipmentFilter.selectedEquipmentType !== this.equipmentType.Scroll
          ? "equipable.hero_id"
          : "hero_id";
      let value = { [field]: className };
      if (
        this.EquipmentFilter.selectedClass.some((type) => type[[field]] === className)
      ) {
        this.EquipmentFilter.selectedClass = this.EquipmentFilter.selectedClass.filter(
          (type) => type[[field]] !== className
        );
      } else {
        this.EquipmentFilter.selectedClass.push(value);
      }
      this.popEquipments();
    },

    toggleStats(statName) {
      let field =
        this.EquipmentFilter.selectedEquipmentType !== this.equipmentType.Scroll
          ? "equipable.statsType"
          : "skillStats";
      let value = { [field]: statName };
      if (this.EquipmentFilter.selectedStats.some((type) => type[[field]] === statName)) {
        this.EquipmentFilter.selectedStats = this.EquipmentFilter.selectedStats.filter(
          (type) => type[[field]] !== statName
        );
      } else {
        this.EquipmentFilter.selectedStats.push(value);
      }
      this.popEquipments();
    },

    toggleEquipmentType() {
      //to reset all filterConditions
      this.resetAll();
      this.popEquipments();
    },
    toggleEquipmentStatus() {
      this.mainFilter.status = this.selectedEquipmentStatus;
      this.trigger.refresh();
    },

    toggleEquipElement() {
      this.mainFilter.element = this.selectedEquipElement;
      this.trigger.refresh();
    },
    async getEquipments(filter, skip, limit) {
      if (filter == {}) filter = { ...this.mainFilter };
      this.isLoading = true;
      let page = skip || 0;
      let pageSize = limit || 10;
      let equipments = await this.api.charequipment.getEquipments(
        this.data.entity.id,
        this.server,
        filter,
        page,
        pageSize
      );
      equipments.data.forEach((equipment) => {
        equipment["expirationDate"] = equipment.expiration
          ? this.ticksToDate(equipment.expiration)
          : "Non-expiry";
      });
      this.isLoading = false;
      return equipments;
    },

    async popEquipments() {
      if (
        this.EquipmentFilter.selectedEquipmentType !== this.equipmentType.Equipable &&
        this.EquipmentFilter.selectedEquipmentType !== this.equipmentType.Costume
      ) {
        this.EquipmentFilter.selectedEquipableTypes = [];
      }
      const filterObject = {
        where: {
          $and: [
            { equipmentType: this.EquipmentFilter.selectedEquipmentType },
            this.EquipmentFilter.selectedEquipableTypes.length > 0
              ? { $or: this.EquipmentFilter.selectedEquipableTypes }
              : {},
            this.EquipmentFilter.selectedClass.length > 0 &&
            this.EquipmentFilter.selectedEquipmentType != this.equipmentType.Scroll
              ? { $or: this.EquipmentFilter.selectedClass }
              : {},
            this.EquipmentFilter.selectedStats.length > 0 &&
            this.EquipmentFilter.selectedEquipmentType != this.equipmentType.Scroll
              ? { $or: this.EquipmentFilter.selectedStats }
              : {},
          ],
        },
      };
      await this.getEquipmentList(encodeURIComponent(JSON.stringify(filterObject)));

      if (this.EquipmentFilter.selectedEquipmentType === this.equipmentType.Scroll) {
        this.skillEquipments = [];
        this.equipmentList.forEach((equipment) => {
          const filterSkill = {
            where: { id: equipment.scroll.skill_id },
          };
          this.checkSkill(encodeURIComponent(JSON.stringify(filterSkill)))
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.json();
            })
            .then((data) => {
              if (data.length !== 0) {
                this.skillEquipments.push(equipment);
              }
            });
        });
      }

      if (this.EquipmentFilter.selectedEquipmentType === this.equipmentType.Scroll) {
        this.equipmentList = this.skillEquipments;
      }
      this.equipmentList.sort(function (a, b) {
        return a.name
          .trim()
          .localeCompare(b.name.trim(), undefined, { sensitivity: "accent" });
      });
    },

    async getEquipmentList(filter) {
      this.equipmentList = await this.api.charequipment.getEquipmentList(filter);
    },

    async checkSkill(filter) {
      return await this.api.charequipment.verifySkill(filter);
    },

    async addEquipment() {
      console.log("Selected Equipment:", this.selectedEquipment);
      this.model.character_id = this.data.entity.id;
      this.errorList = [];
      if (
        this.EquipmentFilter.isExpiration &&
        (this.model.expiration === 0 || this.model.expiration === null)
      ) {
        this.errorList.push("Select valid Expiration");
      }
      if (this.model.quantity <= 0 || this.model.quantity == null) {
        this.errorList.push("Input valid number on quantity");
      }
      if (this.model.hp < 0 || this.model.hp > 3) {
        this.errorList.push("Please input valid number on Health");
      }
      if (this.model.rv < 0 || this.model.rv > 8) {
        this.errorList.push("Please input valid number on Random Value");
      }
      if (this.model.level < 0 || this.model.level > 9) {
        this.errorList.push("Please input valid number on Level");
      }
      if (this.model.engraveLevel < 0 || this.model.engraveLevel > 30) {
        this.errorList.push("Please input valid number on Engrave Level");
      }
      if (this.model.critRate < -15 || this.model.critRate > 15) {
        this.errorList.push("Please input valid number on Critical Rate");
      }
      if (this.model.hitRate < -7 || this.model.hitRate > 7) {
        this.errorList.push("Please input valid number on Hit Rate");
      }
      if (this.model.magicDefense < 0 || this.model.magicDefense > 3) {
        this.errorList.push("Please input valid number on Magic Defense");
      }
      if (this.model.evasion < -7 || this.model.evasion > 7) {
        this.errorList.push("Please input valid number on Evasion");
      }
      if (this.model.element < 0 || this.model.element > 4) {
        this.errorList.push("Please input valid element.");
      }
      if (this.model.energy < 0 || this.model.energy > 65532) {
        this.errorList.push("Please input valid energy value");
      }
      if (this.model.elementLevel < 0 || this.model.elementLevel > 1) {
        this.errorList.push("Please input valid element level.");
      }
      if (this.model.elements[0] < 0 || this.model.elements[0] > 15) {
        this.errorList.push("Please input valid Fire Resistance value.");
      }
      if (this.model.elements[1] < 0 || this.model.elements[1] > 15) {
        this.errorList.push("Please input valid Ice Resistance value.");
      }
      if (this.model.elements[2] < 0 || this.model.elements[2] > 15) {
        this.errorList.push("Please input valid Electric Resistance value.");
      }
      if (this.model.elements[3] < 0 || this.model.elements[3] > 15) {
        this.errorList.push("Please input valid Poison Resistance value.");
      }
      if (this.selectedEquipment == "") {
        this.errorList.push("Please select Equipment/Item");
      }
      if (this.errorList.length == 0) {
        ModalService.Show(
          {
            title: `Add Equipment`,
            message: `Do you want to save ${this.selectedEquipment}?`,
          },
          async () => {

            let res = await this.api.charequipment.addEquipment(
              this.data.entity.id,
              this.server,
              this.model
            );
            if (res.message === "Success") {
              await this.api.auditadmin.postAudit(
                {
                  ...this.model,
                },
                this.store.custom.serverCode,
                this.store.custom.countryCode,
                0
              );
              ToastService.Notify({
                title: "Success",
                message: "Equipment Added!",
              });
              this.resetAll();
              this.showAdd = false;
              this.model = {
                hp: 0,
                energy: 0,
                level: 0,
                rv: 0,
                critRate: 0,
                hitRate: 0,
                evasion: 0,
                magicDefense: 0,
                element: 0,
                elementLevel: 0,
                elements: {
                  0: 0,
                  1: 0,
                  2: 0,
                  3: 0,
                },
                quantity: 1,
                expiration: 0,
                isNonDrop: false,
                isEquiped: false,
              };
              this.selectedEquipment = "";
              this.trigger.refresh();
            } else {
              ToastService.Notify({
                title: "Error",
                message: "Unable to save.",
              });
              this.showAdd = false;
              this.trigger.refresh();
            }
          }
        );
      } else {
        this.showError = true;
      }
    },

    updateEquipments(entity) {
      this.equipmentToUpdate.entity = JSON.parse(JSON.stringify(entity));
      this.equipmentToUpdate.entity.elements =
        this.equipmentToUpdate.entity.elements != null
          ? this.equipmentToUpdate.entity.elements
          : {
              0: 0,
              1: 0,
              2: 0,
              3: 0,
            };
      this.equipmentToUpdate.entity.equippedSkills =
        this.enableUpdatePetSkill
          ? this.equipmentToUpdate.entity.equippedSkills != null ?  this.equipmentToUpdate.entity.equippedSkills : [0,0]
          :
          [
              0,
              0
          ]
      this.equipmentToUpdate.show = true;
      this.equipmentToUpdate.isAdd = true;
      console.log(this.equipmentToUpdate.entity)
    },

    viewEquipment(entity) {
      this.equipmentView.entity = entity;
      this.equipmentView.show = true;
    },

    updateEquipmentId() {
      const select = document.querySelector("#addequipment-list");
      const selectedOption = Array.from(select.options).find(
        (opt) => opt.value === this.selectedEquipment
      );
      if (selectedOption) {
        this.model.equipment_id = parseInt(selectedOption.getAttribute("data-id"));
      }
    },

    async updateEquipment() {
      this.errorList = [];

      if (
        this.equipmentToUpdate.entity.quantity <= 0 ||
        this.equipmentToUpdate.entity.quantity == null
      ) {
        this.errorList.push("Input valid number on quantity");
      }
      if (this.equipmentToUpdate.entity.hp < 0 || this.equipmentToUpdate.entity.hp > 3) {
        this.errorList.push("Please input valid number on Health");
      }
      if (this.equipmentToUpdate.entity.rv < 0 || this.equipmentToUpdate.entity.rv > 8) {
        this.errorList.push("Please input valid number on Random Value");
      }
      if (
        this.equipmentToUpdate.entity.level < 0 ||
        this.equipmentToUpdate.entity.level > 9
      ) {
        this.errorList.push("Please input valid number on Level");
      }
      if (
        this.equipmentToUpdate.entity.engraveLevel < 0 ||
        this.equipmentToUpdate.entity.engraveLevel > 30
      ) {
        this.errorList.push("Please input valid number on Engrave Level");
      }
      if (
        this.equipmentToUpdate.entity.critRate < -15 ||
        this.equipmentToUpdate.entity.critRate > 15
      ) {
        this.errorList.push("Please input valid number on Critical Rate");
      }
      if (
        this.equipmentToUpdate.entity.hitRate < -7 ||
        this.equipmentToUpdate.entity.hitRate > 7
      ) {
        this.errorList.push("Please input valid number on Hit Rate");
      }
      if (
        this.equipmentToUpdate.entity.magicDefense < 0 ||
        this.equipmentToUpdate.entity.magicDefense > 3
      ) {
        this.errorList.push("Please input valid number on Magic Defense");
      }
      if (
        this.equipmentToUpdate.entity.evasion < -7 ||
        this.equipmentToUpdate.entity.evasion > 7
      ) {
        this.errorList.push("Please input valid number on Evasion");
      }
      if (
        this.equipmentToUpdate.entity.element < 0 ||
        this.equipmentToUpdate.entity.element > 4
      ) {
        this.errorList.push("Please input valid element.");
      }
      if (
        this.equipmentToUpdate.entity.elementLevel < 0 ||
        this.equipmentToUpdate.entity.elementLevel > 1
      ) {
        this.errorList.push("Please input valid element level.");
      }
      if (
        this.equipmentToUpdate.entity.elements[0] < 0 ||
        this.equipmentToUpdate.entity.elements[0] > 15
      ) {
        this.errorList.push("Please input valid Fire Resistance value.");
      }
      if (
        this.equipmentToUpdate.entity.elements[1] < 0 ||
        this.equipmentToUpdate.entity.elements[1] > 15
      ) {
        this.errorList.push("Please input valid Ice Resistance value.");
      }
      if (
        this.equipmentToUpdate.entity.elements[2] < 0 ||
        this.equipmentToUpdate.entity.elements[2] > 15
      ) {
        this.errorList.push("Please input valid Electric Resistance value.");
      }
      if (
        this.equipmentToUpdate.entity.elements[3] < 0 ||
        this.equipmentToUpdate.entity.elements[3] > 15
      ) {
        this.errorList.push("Please input valid Poison Resistance value.");
      }
      if (
        this.equipmentToUpdate.entity.energy < 0 ||
        this.equipmentToUpdate.entity.energy > 65532
      ) {
        this.errorList.push("Please input valid Energy Value.");
      }

       if (
        (this.equipmentToUpdate.entity.equippedSkills[0] != 0 && this.equipmentToUpdate.entity.equippedSkills[1] != 0) &&
        (this.equipmentToUpdate.entity.equippedSkills[0] == this.equipmentToUpdate.entity.equippedSkills[1])
      ) {
        this.errorList.push("Duplicate skills detected. Please select a unique ability.");
      }
      if (this.errorList.length == 0) {
        ModalService.Show(
          {
            title: `Update Equipment`,
            message: `Do you want to update ${this.equipmentToUpdate.entity.equipment_name}?`,
          },
          async () => {
            delete this.equipmentToUpdate.entity.equipment_name;
            delete this.equipmentToUpdate.entity.expirationDate;
            delete this.equipmentToUpdate.entity.equipment_equipped;
            delete this.equipmentToUpdate.entity.equipment_element;

            const res = await this.api.charequipment.updateEquipment(
              this.equipmentToUpdate.entity.character_id,
              this.equipmentToUpdate.entity.id,
              this.server,
              this.equipmentToUpdate.entity
            );
            if (res.message === "Success") {
              await this.api.auditadmin.postAudit(
                {
                  ...this.equipmentToUpdate.entity,
                },
                this.store.custom.serverCode,
                this.store.custom.countryCode,
                1
              );
              ToastService.Notify({
                title: "Success",
                message: "Equipment Saved!",
              });
              this.equipmentToUpdate.show = false;
              this.trigger.refresh();
            } else {
              ToastService.Notify({
                title: "Error",
                message: "Unable to save.",
              });
              this.equipmentToUpdate.show = false;
              this.trigger.refresh();
            }
          }
        );
      } else {
        this.showError = true;
      }
    },

    closeModal() {
      this.showAdd = false;
      this.equipmentToUpdate.show = false;
      this.equipmentView.show = false;
      this.resetAll();
    },

    close() {
      let data = this.data;
      data.show = false;
    },

    resetAll() {
      this.EquipmentFilter.selectedEquipableTypes = [];
      this.EquipmentFilter.selectedClass = [];
      this.EquipmentFilter.selectedStats = [];
      this.selectedEquipment = "";
      const checkboxes = document.querySelectorAll('input[id^="chk_"]');
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    },

    //Time / Ticks Related
    getCurrentTicks() {
      const epochticks = 621355968000000000; // Jan 1, 1970 in .NET ticks
      const currentTimestamp = new Date().getTime();
      var ticks = currentTimestamp * 10000; // 10,000,000 nanoseconds in a tick
      return ticks + epochticks;
    },

    calculateTicksFromHours(hours) {
      var hr = hours + 8;
      const millisecondsToAdd = hr * 60 * 60 * 1000;
      return millisecondsToAdd * 10000;
    },

    computeAdditionalTicks(ticks) {
      const currentTicks = this.getCurrentTicks();
      const expiration = currentTicks + ticks;
      if (this.equipmentToUpdate.show) {
        this.equipmentToUpdate.entity.expiration = expiration;
        return;
      }
      this.model.expiration = expiration;
    },

    ticksToDate(ticks) {
      const epochticks = 621355968000000000; // Jan 1, 1970 in .NET ticks
      const tickInMilliseconds = 0.0001;
      const milliseconds = (ticks - epochticks) * tickInMilliseconds;

      // Add 8 hours (UTC+8)
      const offsetMs = 8 * 60 * 60 * 1000;
      const localMilliseconds = milliseconds - offsetMs;

      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      const date = new Date(localMilliseconds);
      const month = months[date.getMonth()];
      const day = date.getDate();
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      hours = String(hours).padStart(2, "0");

      return `${month} ${day}, ${year} ${hours}:${minutes}:${seconds} ${ampm}`;
    },
    onDestroyChange() {
      this.showDestroyModal = true;
    },
    closeDestroyModal() {
      this.showDestroyModal = false;
    },
    confirmDestroy() {
      this.isDestroy = true;
      this.closeDestroyModal();
    },

    cancelDestroy() {
      this.isDestroy = false;
      this.closeDestroyModal();
    },
  },
  async mounted() {
    this.popEquipments();
  },
};
</script>

<style scoped></style>
